var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.label)?_c('label',{class:_vm.labelClassName,attrs:{"for":_vm.id}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),(_vm.helper)?_c('span',{class:_vm.$spa.css.form.helper},[_vm._v(_vm._s(_vm.helper))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }